/* @ngInject */
const go = (

) => {
  const self = {}

  return self
}

export default go



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/services/go.service.js